// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { reduxForm, Field } from 'redux-form';
import { translate } from 'react-i18next';

import { Form, STextField, ButtonSubmit } from '../styles';
import { emailValidator, mapErrorCode } from '../domain/validations';

const Message = styled.div`
  margin: ${({ theme }) => `${theme.metrics.largeMargin}px 0`};
  overlow-wrap: break-word;
  word-wrap: break-word;
`;

type ForgotPasswordValues = {
  email?: string,
};

const fieldsToValidate = ['email'];

const validate = (fields: ForgotPasswordValues) => {
  const errors = {};
  const emailValidation = emailValidator(fields.email);
  if (!emailValidation.isValid) {
    errors.email = mapErrorCode(emailValidation.errorCode);
  }
  return errors;
};

type Props = {
  onSubmit: (fields: Object) => void,
  handleSubmit: Function,
  theme: Object,
  t: any,
}

function ForgotPasswordForm({ onSubmit, handleSubmit, theme, t }: Props) {
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Message style={theme.fonts.style.sub}>{t('provideYourEmail')}</Message>
      <Field component={STextField} name="email" type="email" floatingLabelText={t('email')} />
      <ButtonSubmit type="submit" style={{ marginTop: theme.metrics.largeMargin }}>{t('send')}</ButtonSubmit>
    </Form>
  );
}

export default withTheme(translate('commonAuthentication')(reduxForm({
  form: 'RequestPaswordResetForm',
  fields: fieldsToValidate,
  validate: validate,
})(ForgotPasswordForm)));




// WEBPACK FOOTER //
// ./src/common/modules/authentication/resetPassword/ForgotPasswordForm.js